import { Empty, Skeleton } from 'antd';
import { getCookie } from 'helper/cookie';
// import { useT } from 'i18n/index';

export const renderSkeletonTable = (
  row: number,
  isLoading: any,
  empty?: any
) => {
  const skeletonCount = row; // Number of Skeleton.Button elements
  const skeletonElements = [];
  const lang = getCookie('lang');
  // const $t = useT();

  for (let i = 0; i < skeletonCount; i++) {
    skeletonElements?.push(
      <div key={i} style={{ marginBottom: '10px' }}>
        <Skeleton.Button
          active
          block={true}
          style={{ height: '50px', opacity: 0.4 }}
        />
      </div>
    );
  }

  return (
    <>
      {isLoading
        ? skeletonElements
        : empty || <Empty description={<span>{lang === 'th' ? 'ไม่มีข้อมูล' : 'No Data'}</span>} />}
    </>
  );
};
